var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex -mx-3 text-sm"},[_c('div',{staticClass:"flex-1 px-3"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('name')))+" / url")])])
}
var staticRenderFns = []

export { render, staticRenderFns }